import * as z from "zod/v4";

const LinearCommentSchema_ = z.object({
  id: z.string(),
  body: z.string(),
  createdAt: z.string(),
  authorName: z.string(),
  authorEmail: z.string().nullable().optional(),
});

export const LinearCommentSchema: z.ZodType<LinearComment> =
  LinearCommentSchema_;
export interface LinearComment extends z.infer<typeof LinearCommentSchema_> {}

const IssueMetadataSchema_ = z.object({
  teamId: z.string().optional(),
  stateId: z.string().optional(),
  priority: z.number().optional(),
  assigneeId: z.string().nullable().optional(),
  labelIds: z.array(z.string()).optional(),
});

export const IssueMetadataSchema: z.ZodType<IssueMetadata> =
  IssueMetadataSchema_;
export interface IssueMetadata extends z.infer<typeof IssueMetadataSchema_> {}

export const getLinearComments = {
  name: "getLinearComments" as const,
  input: z.object({ linearTicketId: z.string() }),
  output: z.object({
    comments: z.array(LinearCommentSchema),
    ticketTitle: z.string(),
    ticketIdentifier: z.string(),
    ticketCreator: z.string().nullable(),
    ticketDescription: z.string().nullable(),
    issueMetadata: IssueMetadataSchema.optional(),
  }),
};
